import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { DateFormat } from "@avenueops/web-components";
import { useUser } from "context/UserContext";

interface Props {
  row: SQLGeneratedProcess;
}

export default function Comments({ row }: Props): JSX.Element {
  const user = useUser();
  return (
    <span>
      {getNumCommentReplies(row.commentsLength)}
      {row.lastCommentedAt ? (
        <span className="text-gray-500 text-xs">
          <span className="sm:inline hidden ml-1 mr-1"> • </span>
          Last reply <DateFormat type="RELATIVE" timeZone={user.timeZone ?? undefined} date={row.lastCommentedAt} />
        </span>
      ) : null}
    </span>
  );
}

function getNumCommentReplies(num: number): string {
  return `${num} repl${num !== 1 ? "ies" : "y"}`;
}
